"use client";

import { useEffect, useRef } from 'react';

/**
 * 组件用于修复水合错误，通过移除不必要的属性（如xt-marked）
 */
export default function HydrationFix({ children }) {
  const rootRef = useRef(null);
  
  useEffect(() => {
    if (!rootRef.current) return;
    
    // 找到所有带有 xt-marked 属性的元素并移除该属性
    const elements = rootRef.current.querySelectorAll('[xt-marked]');
    elements.forEach(el => {
      el.removeAttribute('xt-marked');
    });
  }, []);
  
  return (
    <div ref={rootRef}>
      {children}
    </div>
  );
} 